import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { api } from "../services/apiService";
import type from "../actions/types";
import { isApiFailure } from "./apiFailure";

function* fetchReferralCode() {
    try {
        const res = yield call(api.getReferralCode);
        // getReferralCode is doGetCall-backed: a failure resolves {status, errMsg},
        // never errStatus — the old errStatus-only guard dispatched SUCCESS on
        // failure (#603 gate finding 4).
        if (isApiFailure(res)) {
            yield put({ type: type.REFERRAL_FETCH_CODE_ERROR, errorMsg: res.errMsg });
        } else {
            yield put({ type: type.REFERRAL_FETCH_CODE_SUCCESS, referralCode: res });
        }
    } catch (e) {
        yield put({ type: type.REFERRAL_FETCH_CODE_ERROR, errorMsg: e.message });
    }
}

function* fetchReferralStats() {
    try {
        const res = yield call(api.getReferralStats);
        if (isApiFailure(res)) {
            yield put({ type: type.REFERRAL_FETCH_STATS_ERROR, errorMsg: res.errMsg });
        } else {
            yield put({ type: type.REFERRAL_FETCH_STATS_SUCCESS, stats: res });
        }
    } catch (e) {
        yield put({ type: type.REFERRAL_FETCH_STATS_ERROR, errorMsg: e.message });
    }
}

// Test seam: failure classification (the api layer never rejects).
export const testable = { fetchReferralCode, fetchReferralStats };

function* watchFetchReferralCode() {
    yield takeEvery(type.REFERRAL_FETCH_CODE_REQUEST, fetchReferralCode);
}

function* watchFetchReferralStats() {
    yield takeEvery(type.REFERRAL_FETCH_STATS_REQUEST, fetchReferralStats);
}

export default function* referralSaga() {
    yield all([
        fork(watchFetchReferralCode),
        fork(watchFetchReferralStats)
    ]);
}
